<div class="mx-auto space-y-6">
  <nz-card>
    <div nz-row nzGutter="24" class="items-start">
      <!-- Left Column - Avatar and Role -->
      <div nz-col nzXs="24" nzSm="24" nzMd="4" nzLg="4" nzXl="4" class="flex flex-col items-center mb-6 md:mb-0">
        <h6 class="text-sm font-semibold text-gray-700 mb-4 uppercase tracking-wider text-center">Basic Details</h6>
        <div
          class="w-20 h-20 md:w-24 md:h-24 bg-gradient-to-r from-primary to-primary/95 rounded-full flex items-center justify-center text-white mb-4 shadow-xl border-4 border-white">
          <i nz-icon nzType="user" nzTheme="outline" class="text-2xl md:text-3xl"></i>
        </div>
        <p class="text-xs sm:text-sm font-medium text-gray-700 bg-blue-50 px-3 sm:px-4 py-1 sm:py-2 rounded-full border border-blue-100 shadow-sm text-center truncate max-w-full">
          {{profileData.role}}</p>
      </div>
      <!-- Right Column - Form -->
      <div nz-col nzXs="24" nzSm="24" nzMd="20" nzLg="20" nzXl="20">
        <div nz-row nzGutter="0">
          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">

            <form nz-form nzLayout="vertical" [formGroup]="profileForm" *ngIf="isEditing" class="w-full">
              <div nz-row nzGutter="24">
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                  <nz-form-item>
                    <nz-form-label class="block text-sm font-medium text-gray-700">First Name</nz-form-label>
                    <nz-form-control [nzErrorTip]="firstNameError">
                      <input nz-input formControlName="first_name" class="w-full rounded-md" />
                    </nz-form-control>
                  </nz-form-item>
                  <ng-template #firstNameError>
                    @if(profileForm.get('first_name')?.hasError('required')){
                    <span class="text-xsm">First name is required.</span>
                    }
                    @if(profileForm.get('first_name')?.hasError('minlength')){
                    <span class="text-xsm">Minimum 2 characters required.</span>
                    }
                  </ng-template>
                </div>
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                  <nz-form-item>
                    <nz-form-label class="block text-sm font-medium text-gray-700">Last Name</nz-form-label>
                    <nz-form-control [nzErrorTip]="lastNameError">
                      <input nz-input formControlName="last_name" class="w-full rounded-md" />
                    </nz-form-control>
                  </nz-form-item>
                  <ng-template #lastNameError>
                    @if(profileForm.get('last_name')?.hasError('required')){
                    <span class="text-xsm">Last name is required.</span>
                    }
                    @if(profileForm.get('last_name')?.hasError('minlength')){
                    <span class="text-xsm">Minimum 2 characters required.</span>
                    }
                  </ng-template>
                </div>
                <!-- Email (Readonly) -->
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                  <nz-form-item>
                    <nz-form-label class="block text-sm font-medium text-gray-700">Email</nz-form-label>
                    <nz-form-control>
                      <nz-input-group [nzPrefix]="emailPrefix" class="rounded-md">
                        <input nz-input [value]="profileData.email"
                          class="w-full bg-gray-50 cursor-not-allowed rounded-md" readonly />
                      </nz-input-group>
                      <ng-template #emailPrefix>
                        <i nz-icon nzType="mail" class="text-gray-400 mr-2"></i>
                      </ng-template>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <!-- Contact (Readonly) -->
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                  <nz-form-item>
                    <nz-form-label class="block text-sm font-medium text-gray-700">Contact</nz-form-label>
                    <nz-form-control>
                      <nz-input-group [nzPrefix]="phonePrefix" class="rounded-md">
                        <input nz-input [value]="profileData.contact"
                          class="w-full bg-gray-50 cursor-not-allowed rounded-md" readonly />
                      </nz-input-group>
                      <ng-template #phonePrefix>
                        <i nz-icon nzType="phone" class="text-gray-400 mr-2 rotate-180"></i>
                      </ng-template>
                    </nz-form-control>
                  </nz-form-item>
                </div>

              </div>
              <!-- Submit Button -->
              <div class="flex justify-end">
                <button nz-button nzType="default" class="mr-3" (click)="isEditing = false" type="button">Cancel</button>
                <button nz-button nzType="primary" [disabled]="profileForm.invalid || profileForm.pristine"
                  (click)="onProfileSubmit()" class="px-6">Update</button>
              </div>
            </form>

            <div *ngIf="!isEditing" class="w-full">
              <div class="bg-gray-50 p-6 border border-gray-200 rounded-lg flex justify-between items-center">
                <div nz-row [nzGutter]="[24, 24]">
                  <div nz-col nzXs="24" nzMd="12">
                    <p class="flex items-center">
                      <i nz-icon nzType="user" class="mr-3 text-primary text-lg p-2 bg-blue-50 rounded-full"></i>
                      <span>
                        <strong class="text-primary mr-2">First Name:</strong>
                        {{profileData.firstName}}
                      </span>
                    </p>
                  </div>
                  <div nz-col nzXs="24" nzMd="12">
                    <p class="flex items-center">
                      <i nz-icon nzType="user" class="mr-3 text-primary text-lg p-2 bg-blue-50 rounded-full"></i>
                      <span>
                        <strong class="text-primary mr-2">Last Name:</strong>
                        {{profileData.lastName}}
                      </span>
                    </p>
                  </div>
                  <div nz-col nzXs="24" nzMd="12">
                    <p class="flex items-center">
                      <i nz-icon nzType="mail" class="mr-3 text-primary text-lg p-2 bg-blue-50 rounded-full"></i>
                      <span><strong class="text-primary mr-2">Email:</strong> {{profileData.email}}</span>
                    </p>
                  </div>
                  <div nz-col nzXs="24" nzMd="12">
                    <p class="flex items-center">
                      <i nz-icon nzType="phone" class="mr-3 text-primary text-lg rotate-180 p-2 bg-blue-50 rounded-full"></i>
                      <span><strong class="text-primary mr-2">Contact:</strong> {{profileData.contact}}</span>
                    </p>
                  </div>
                </div>
                <div class="flex justify-end">
                  <button (click)="this.isEditing = !this.isEditing;" nz-button nzType="primary" nzShape="circle">
                    <i nz-icon [nzType]="isEditing ? 'close' : 'edit'" nzTheme="outline"></i>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </nz-card>
  <!-- Change Password -->
  <nz-card>
    <div nz-row nzGutter="24" class="items-start">
      <div nz-col nzXs="24" nzSm="24" nzMd="4" nzLg="4" nzXl="4" class="flex flex-col items-center mb-6 md:mb-0">
        <h6 class="text-sm font-semibold text-gray-700 mb-4 uppercase tracking-wider text-center">Security Settings</h6>
        <div
          class="w-20 h-20 md:w-24 md:h-24 bg-gradient-to-r from-primary to-primary/95 rounded-full flex items-center justify-center text-white shadow-xl border-4 border-white">
          <i nz-icon nzType="lock" nzTheme="outline" class="text-2xl md:text-3xl"></i>
        </div>
      </div>
      <div nz-col nzXs="24" nzSm="24" nzMd="20" nzLg="20" nzXl="20">
        <form nz-form [formGroup]="passwordForm" (ngSubmit)="onPasswordSubmit()" nzLayout="vertical">
          <input type="text" name="username" autocomplete="username" style="display:none" aria-hidden="true" />
          <div nz-row [nzGutter]="[24, 16]">
            <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8" nzXl="8">
              <nz-form-item>
                <nz-form-control [nzErrorTip]="oldPasswordError">
                  <nz-form-label class="text-sm font-medium text-gray-700">Current Password</nz-form-label>
                  <nz-input-group [nzSuffix]="oldPasswordSuffix" class="rounded-md shadow-sm">
                    <input [type]="oldPasswordVisible ? 'text' : 'password'" nz-input formControlName="oldPassword"
                      [maxLength]="10" appNoSpaces placeholder="Enter current password" autocomplete="current-password"
                      class="hover:border-primary focus:border-primary transition-colors duration-300" />
                  </nz-input-group>
                </nz-form-control>
                <ng-template #oldPasswordSuffix>
                  <i nz-icon [nzType]="oldPasswordVisible ? 'eye' : 'eye-invisible'"
                    (click)="oldPasswordVisible = !oldPasswordVisible"
                    class="cursor-pointer text-gray-500 hover:text-primary transition-colors duration-200"></i>
                </ng-template>
                <ng-template #oldPasswordError>
                  @if(passwordForm.get('oldPassword')?.hasError('required')){
                  <span class="text-xsm">Current password is required</span>
                  }
                </ng-template>
              </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="8" nzXl="8">
              <nz-form-item>
                <nz-form-control [nzErrorTip]="newPasswordError">
                  <nz-form-label class="text-sm font-medium text-gray-700">New Password</nz-form-label>
                  <nz-input-group [nzSuffix]="newPasswordSuffix" class="rounded-md shadow-sm">
                    <input [type]="newPasswordVisible ? 'text' : 'password'" nz-input formControlName="newPassword"
                      [maxLength]="10" appNoSpaces="nospace" placeholder="Enter new password" autocomplete="new-password"
                      class="hover:border-primary focus:border-primary transition-colors duration-300" />
                  </nz-input-group>
                </nz-form-control>
                <ng-template #newPasswordSuffix>
                  <i nz-icon [nzType]="newPasswordVisible ? 'eye' : 'eye-invisible'"
                    (click)="newPasswordVisible = !newPasswordVisible"
                    class="cursor-pointer text-gray-500 hover:text-primary transition-colors duration-200">
                  </i>
                </ng-template>
                <ng-template #newPasswordError>
                  @if(passwordForm.get('newPassword')?.hasError('required')){
                  <span class="text-xsm">New password is required</span>
                  }
                  @if(passwordForm.get('newPassword')?.hasError('pattern')){
                  <span class="text-xsm">{{ "8-10 characters, at least one uppercase, one lowercase, one number, and one special character (allowed special characters: @$!%*?&)"}}</span>
                  }
                  @if(passwordForm.get('newPassword')?.hasError('sameAsOld')){
                  <span class="text-xsm">New password cannot be the same as the current password</span>
                  }
                  @if(passwordForm.get('newPassword')?.hasError('minlength') && !passwordForm.get('newPassword')?.hasError('pattern')){
                  <span class="text-xsm">Minimum 8 characters required</span>
                  }
                </ng-template>
              </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="8" nzXl="8">
              <nz-form-item>
                <nz-form-control [nzErrorTip]="confirmPasswordError">
                  <nz-form-label class="text-sm font-medium text-gray-700">Confirm Password</nz-form-label>
                  <nz-input-group [nzSuffix]="confirmPasswordSuffix" class="rounded-md shadow-sm">
                    <input [type]="confirmPasswordVisible ? 'text' : 'password'" nz-input [maxLength]="10" appNoSpaces="nospace"
                      formControlName="confirmPassword" placeholder="Confirm new password" autocomplete="new-password"
                      class="hover:border-primary focus:border-primary transition-colors duration-300" />
                  </nz-input-group>
                </nz-form-control>
                <ng-template #confirmPasswordSuffix>
                  <i nz-icon [nzType]="confirmPasswordVisible ? 'eye' : 'eye-invisible'"
                    (click)="confirmPasswordVisible = !confirmPasswordVisible"
                    class="cursor-pointer text-gray-500 hover:text-primary transition-colors duration-200">
                  </i>
                </ng-template>
                <ng-template #confirmPasswordError>
                  @if(passwordForm.get('confirmPassword')?.hasError('required')){
                  <span class="text-xsm">Confirm password is required</span>
                  }
                  @if(passwordForm.get('confirmPassword')?.hasError('pattern')){
                    <span class="text-xsm">{{ "8-10 characters, at least one uppercase, one lowercase, one number, and one special character (allowed special characters: @$!%*?&)"}}</span>
                  }
                  @if(passwordForm.get('confirmPassword')?.hasError('passwordMismatch')){
                  <span class="text-xsm">Passwords do not match</span>
                  }
                  @if(passwordForm.get('confirmPassword')?.hasError('minlength') && !passwordForm.get('confirmPassword')?.hasError('pattern')){
                  <span class="text-xsm">Minimum 8 characters required</span>
                  }
                </ng-template>
              </nz-form-item>
            </div>
          </div>
          <!-- Submit Button -->
          <div class="flex justify-end">
            <button nz-button nzType="primary" [disabled]="passwordForm.invalid || passwordForm.pristine"
              type="submit" class="px-6">Update Password</button>
          </div>
        </form>
      </div>
    </div>
  </nz-card>
  <!-- Preferences -->
  <nz-card>
    <div nz-row nzGutter="24" class="items-start">
      <!-- Left Column - Preferences Icon -->
      <div nz-col nzXs="24" nzSm="24" nzMd="4" nzLg="4" nzXl="4" class="flex flex-col items-center mb-6 md:mb-0">
        <h6 class="text-sm font-semibold text-gray-700 mb-4 uppercase tracking-wider text-center">Preferences</h6>
        <div
          class="w-20 h-20 md:w-24 md:h-24 bg-gradient-to-r from-primary to-primary/95 rounded-full flex items-center justify-center text-white shadow-xl border-4 border-white">
          <i nz-icon nzType="setting" nzTheme="outline" class="text-2xl md:text-3xl"></i>
        </div>
      </div>
      <!-- Right Column - Preferences Form -->
      <div nz-col nzXs="24" nzSm="24" nzMd="20" nzLg="20" nzXl="20">
        <form nz-form [formGroup]="preferencesForm" (ngSubmit)="onPreferencesSubmit()" nzLayout="vertical">
          <div nz-row [nzGutter]="[24, 16]">
            <div nz-col nzXs="24" nzSm="12">
              <nz-form-item>
                <nz-form-label class="text-sm font-medium text-gray-700">Temperature Unit</nz-form-label>
                <nz-form-control>
                  <nz-select formControlName="tempPreference" class="w-full shadow-sm"
                    nzPlaceHolder="Select temperature unit">
                    <nz-option nzValue="D" nzLabel="Degree Celsius (°C)"></nz-option>
                    <nz-option nzValue="F" nzLabel="Fahrenheit (°F)"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="12">
              <nz-form-item>
                <nz-form-label class="text-sm font-medium text-gray-700">Time Zone</nz-form-label>
                <nz-form-control>
                  <nz-select formControlName="timezone" class="w-full shadow-sm" nzShowSearch
                    nzPlaceHolder="Select your time zone">
                    <nz-option *ngFor="let tz of timezones" [nzValue]="tz.value" [nzLabel]="tz.name"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          <div class="flex justify-end">
            <button nz-button nzType="primary" [disabled]="preferencesForm.invalid || preferencesForm.pristine"
              type="submit" class="px-6">Update Preferences</button>
          </div>
        </form>
      </div>
    </div>
  </nz-card>
</div>